// Formatage d'une date ISO en local FR ; retombe sur la valeur brute si invalide.
export const formatDate = (iso) => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleString('fr-FR');
};
